import { z } from "zod";
import { sourceOptionSchema } from "./monitoring.js";

export const revisionResultSchema = z.object({ revision: z.number() });
export const okResultSchema = z.object({ ok: z.literal(true) });
export const createdIdSchema = z.object({ id: z.string() });
export const stateResultSchema = z.object({ state: z.string() });

export const recoveryStartedSchema = z.object({ job_id: z.string(), included: z.number() });
export const jobCancelledSchema = z.object({ started: z.number() });
export const accessChangedSchema = z.object({ audit_id: z.string() });
export const sourceOptionsResponseSchema = z.object({ sources: z.array(sourceOptionSchema) });
export const sourceEditedSchema = z.object({ revision: z.number(), plans_pending: z.number() });
export const scanStartedSchema = z.object({ scan_id: z.string() });
export const extensionStartedSchema = z.object({ id: z.string(), state: z.string() });
